import type { CmpHider } from './types';

export const tarteaucitron: CmpHider = {
  id: 'tarteaucitron',
  label: 'Tarteaucitron',
  css: `
      /* Tarteaucitron (tarteaucitron.js, the French open-source GDPR CMP): the
         whole consent UI is mounted inside a single root container
         "#tarteaucitronRoot" appended to <body>, which holds the first-visit
         banner ("#tarteaucitronAlertBig"), the small returning-visitor banner
         ("#tarteaucitronAlertSmall"), the preferences panel ("#tarteaucitron",
         z-index 2147483647) and its separate fixed full-viewport dimming
         backdrop ("#tarteaucitronBack", bg #eee opacity 0.7, z-index
         2147483646). Hiding "#tarteaucitronRoot" removes the banners, the panel,
         and the backdrop in one go, but tarteaucitron also leaves a persistent
         fixed floating "cookies manager" icon ("#tarteaucitronIcon" wrapping
         "#tarteaucitronManager", position:fixed, z-index 2147483646, ~70x68px)
         that stays over the page after consent — it is rendered outside the root
         on the sites observed, so we hide it explicitly. We also list
         "#tarteaucitronBack" defensively in case a build mounts the backdrop
         outside the root. Tarteaucitron locks page scroll by adding the
         "tarteaucitronBeforeVisible" class to <body> while a banner/panel is
         open (its own "body.tarteaucitronBeforeVisible { overflow: hidden }"
         rule is injected at runtime AFTER this style, so matching its specificity
         plus !important loses on source order) — we lead with "html body" to
         out-specify it. The existing inline-overflow release ([style*="overflow"])
         does not cover this class-based lock. */
      #tarteaucitronRoot,
      #tarteaucitronBack,
      #tarteaucitronIcon { display: none !important; }
      html body.tarteaucitronBeforeVisible {
        overflow: visible !important;
        position: static !important;
      }
  `,
};
